import { updateItems } from "@/mocks/site";
import { dramas } from "@/mocks/dramas";

function progressOf(title: string) {
  const found = dramas.find((d) => d.title === title);
  if (!found) return 60;
  return Math.round((found.progress / found.episodes) * 100);
}

function statusOf(title: string) {
  const found = dramas.find((d) => d.title === title);
  return found ? found.status : "连载中";
}

export default function NewReleases() {
  return (
    <section id="new" className="w-full border-b border-background-200 bg-background-100/70">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-12 md:px-8 md:py-16">
        <div className="flex flex-wrap items-end justify-between gap-3">
          <div>
            <span className="text-xs font-semibold uppercase tracking-widest text-accent-700">New Episodes</span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">最新更新</h2>
            <p className="mt-2 max-w-2xl text-sm text-foreground-600">
              更新条里的每一部都在下方有对应合集，进度按已更新集数折算。连载中的条目会持续补充新集。
            </p>
          </div>
          <span className="inline-flex items-center gap-1.5 rounded-md border border-background-300 bg-background-50 px-3 py-1.5 text-xs text-foreground-600">
            <span className="flex h-3.5 w-3.5 items-center justify-center text-primary-600">
              <i className="ri-refresh-line text-sm" aria-hidden="true" />
            </span>
            共 {updateItems.length} 条更新记录
          </span>
        </div>

        <div className="mt-8 overflow-hidden rounded-lg border border-background-200 bg-background-50">
          <div className="hidden grid-cols-[3.5rem_1.6fr_1fr_1fr_6rem] items-center gap-4 border-b border-background-200 bg-background-100 px-4 py-3 text-xs font-medium text-foreground-500 md:grid">
            <span>序号</span>
            <span>剧集名称</span>
            <span>更新进度</span>
            <span>状态</span>
            <span className="text-right">更新时间</span>
          </div>

          <ul>
            {updateItems.map((item, index) => {
              const pct = progressOf(item.title);
              return (
                <li
                  key={item.id}
                  className="grid grid-cols-1 gap-3 border-b border-background-200 px-4 py-4 last:border-b-0 transition-colors hover:bg-primary-50/50 md:grid-cols-[3.5rem_1.6fr_1fr_1fr_6rem] md:items-center md:gap-4"
                >
                  <span className="flex h-8 w-8 items-center justify-center rounded-md bg-secondary-100 font-heading text-sm font-bold text-secondary-800">
                    {String(index + 1).padStart(2, "0")}
                  </span>

                  <div className="min-w-0">
                    <p className="truncate font-medium text-foreground-900">{item.title}</p>
                    <p className="mt-0.5 text-xs text-foreground-500">{item.note}</p>
                  </div>

                  <div className="flex items-center gap-2">
                    <div className="h-1.5 w-full overflow-hidden rounded-full bg-background-200">
                      <div
                        className="h-full rounded-full bg-primary-500"
                        style={{ width: `${pct}%` }}
                      />
                    </div>
                    <span className="w-9 shrink-0 text-right text-xs text-foreground-500">{pct}%</span>
                  </div>

                  <span
                    className={`inline-flex w-fit items-center gap-1 rounded-full px-2.5 py-1 text-xs ${
                      statusOf(item.title) === "已完结"
                        ? "bg-accent-100 text-accent-900"
                        : "bg-primary-100 text-primary-800"
                    }`}
                  >
                    <span className="flex h-3 w-3 items-center justify-center">
                      <i className="ri-vidicon-line text-xs" aria-hidden="true" />
                    </span>
                    {statusOf(item.title)}
                  </span>

                  <span className="text-xs text-foreground-500 md:text-right">{item.time}</span>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </section>
  );
}